import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class AccountChargeData extends EntityData<AccountChargeData> {
    @identifier chargeId: number;
    @field referenceNo: number;
    @field amtDue: number;
    @field chargeAmt: number;
    @field chargeDate: Date;
    @field status: string;
}
